import moment from 'moment';

/**
 * Drop-in replacement for react-moment (incompatible with Vite ESM bundling).
 */
const FormatDate = ({ format, children }) => {
  if (children == null || children === '') {
    return null;
  }

  const parsed = moment(children);
  if (!parsed.isValid()) {
    return null;
  }

  return parsed.format(format);
};

export default FormatDate;
